import React, {Component} from 'react'
import {Badge} from "reactstrap"
import {_proxyStatistics} from "../../../../../services/apis/ProxiesServices"

const badgeColorMap = {
    active: 'success',
    offline: 'danger'
}

class ProxyStatistics extends Component {
    state = {
        statistics: [],
        loading: false
    }

    _refresh = null

    componentDidMount() {
        this._fetchStatistics()
        this._refresh = setInterval(this._fetchStatistics, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._fetchStatistics)
    }

    _fetchStatistics = async () => {
        if (this.state.loading) return

        this.setState({
            loading: true
        })

        try {
            const {success, data} = await _proxyStatistics()
            const newState = {
                loading: false
            }

            if (success) {
                newState.statistics = data
            }

            this.setState(newState)
        } catch (e) {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        return (
            <div className="ProxyStatistics col-md-4 col-12">
                {
                    this.state.statistics.map((statistics, index) => {
                        const {status, total} = statistics
                        return (
                            <div key={index} className="Statistic">
                                <span className="Status">
                                    <Badge color={badgeColorMap[status]} pill>{status}</Badge>
                                </span>
                                <span className="Total">{total}</span>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export default ProxyStatistics



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/ProxyStatistics.js